export default "__VITE_ASSET__BZKVZ6NX__"